import { Component, OnInit } from '@angular/core';

import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';

import { WampService } from 'src/app/services/wamp.service';
import { BecareService } from 'src/app/services/becare.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { PatientService } from 'src/app/services/patient.service';

declare var gBeCareLogo: any; // comes from GeneralTemplateResponsive.php

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  task: any;

  constructor(private wamp: WampService, public becare: BecareService, public patient: PatientService,
              public userConfig: UserConfigService,
              private cookies: CookieService, private devicedetect: DeviceDetectorService) {
    this.userConfig.configLoaded.subscribe(config => {
      console.log('user config loaded');
      console.log(config);
      this.wamp.connectedEvent.subscribe(result => {
        this.wamp.registerSession({
          timetamp: new Date(),
          userid: this.userConfig.userid,
          phpsessionid: this.userConfig.sessionid,
          remoteaddr: this.userConfig.remoteaddr,
          deviceinfo: this.devicedetect.getDeviceInfo()
        });
      });
  });

//     this.logo = (typeof gBeCareLogo === 'undefined') ? '' : gBeCareLogo;
//     console.log('Hello BecareHeaderComponent Component');
//     this.task = setInterval(() => {
// //        this.refreshDashboard();
//     }, 60000);
  }

  ngOnInit(): void {
  }

}
